import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { PENDING_TO_RETURN } from './actionTypes';
import { pentingToReturnTaskSuccessful,pentingToReturnTaskFailed} from './actions';

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

// Is user return successfull then direct plot user in redux.
function* pendingToReturnTask({ payload: { task, token } }) {
    try {

         yield call(tasksAPI.pendingToReturn,task.sgtTaskid,task.taskCode,task.sgpWS,task.sgtWS,task.rackCode,token );
         // P01021-147: history.go() recargaba la página entera (perdiendo el filtro aplicado en
         // la tabla de tareas) — la página escucha pendingToreturnTaskLoading y refresca el listado.

        yield put(pentingToReturnTaskSuccessful("PENDING TO RETURN task correct"));

    } catch (error) {
        yield put(pentingToReturnTaskFailed(error));
    }
}

export function* watchPendingToReturnTask() {
    yield takeEvery(PENDING_TO_RETURN, pendingToReturnTask);
}

function* pendingToReturnTaskSaga() {
    yield all([fork(watchPendingToReturnTask)]);
}

export default pendingToReturnTaskSaga;